import type { Passenger } from '@optionway/models';
import { DateTime } from 'luxon';

const errorPrefix = 'components.passengers.form.errors';

const MAX_AGE_YEARS = 120;
const ADULT_MIN_AGE_YEARS = 12;
const INFANT_MAX_AGE_YEARS = 2;

export const validateBirthdate = (
  passenger: Passenger,
  referenceDate: string | undefined,
  now: string,
): string | undefined => {
  if (!passenger.birthdate) {
    return;
  }
  const birthdate = DateTime.fromISO(passenger.birthdate).startOf('day');
  const today = DateTime.fromISO(now).startOf('day');
  if (!birthdate.isValid || !today.isValid) {
    return;
  }
  if (birthdate > today) {
    return `${errorPrefix}.birthdateFuture`;
  }
  if (birthdate < today.minus({ years: MAX_AGE_YEARS })) {
    return `${errorPrefix}.birthdateTooOld`;
  }
  if (!referenceDate) {
    return;
  }
  const reference = DateTime.fromISO(referenceDate).startOf('day');
  if (!reference.isValid) {
    return;
  }
  return birthdateErrorForType(passenger.type, birthdate, reference);
};

const birthdateErrorForType = (
  type: Passenger['type'],
  birthdate: DateTime,
  reference: DateTime,
): string | undefined => {
  const adultThreshold = reference.minus({ years: ADULT_MIN_AGE_YEARS });
  const infantThreshold = reference.minus({ years: INFANT_MAX_AGE_YEARS });
  if (type === 'ADULT' && birthdate > adultThreshold) {
    return `${errorPrefix}.adultAge`;
  }
  if (type === 'CHILD' && (birthdate > infantThreshold || birthdate <= adultThreshold)) {
    return `${errorPrefix}.childAge`;
  }
  if (type === 'INFANT' && birthdate <= infantThreshold) {
    return `${errorPrefix}.infantAge`;
  }
};
